import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
// NOTE: Keep styles.css before App so that our styles override antd's styles
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryParamProvider } from 'use-query-params';
import { Loading } from './components';
import { store, persistor } from './store';
import ErrorMessages from './constants/ErrorMessages';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import './styles.css';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <PersistGate loading={<Loading size="large" />} persistor={persistor}>
        <ConfigProvider
          form={{ validateMessages: ErrorMessages }}
          theme={{
            token: { colorPrimary: '#531dab' },
            algorithm: theme.defaultAlgorithm,
            components: {
              Segmented: {
                itemSelectedBg: '#673ab7',
                itemSelectedColor: '#ffffff',
              },
              // Layout: {
              //   colorBgHeader: '#531dab',
              //   colorBgTrigger: '#531dab',
              // },
              // Menu: {
              // colorItemBg: '#531dab',
              // },
            },
          }}
        >
          <BrowserRouter>
            <QueryParamProvider adapter={ReactRouter6Adapter}>
              <App />
            </QueryParamProvider>
          </BrowserRouter>
        </ConfigProvider>
      </PersistGate>
    </Provider>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
